export default "__VITE_ASSET__pB1hx0Xb__"